import type { BlogPost } from '../../../../../../../types';

export const useCover = (media: BlogPost['media']) => {
  const emptyImage = createImageData();

  if (media?.wixMedia?.image) {
    const { url, width, height } = media.wixMedia.image;
    return createImageData(url, width, height);
  }

  if (media?.wixMedia?.videoV2) {
    const poster = media.wixMedia.videoV2.posters?.[0];
    if (poster) {
      const { url, width, height } = poster;
      return createImageData(url, width, height);
    }
    return emptyImage;
  }

  if (media?.embedMedia?.thumbnail) {
    const { url, width, height } = media.embedMedia.thumbnail;
    return createImageData(url, width, height);
  }

  return emptyImage;
};

const createImageData = (url: string = '', width?: number, height?: number) => {
  const aspectRatio = width && height ? +(width / height).toFixed(4) : 1;
  return {
    url,
    width,
    height,
    aspectRatio,
  };
};
